import React from 'react';
import Localize from 'react-intl-universal';

import { alpha } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import DynamicFilters from '@components/DymanicFilters/DynamicFilters';

const StyledFilterBox = styled(Box)(({ theme }) => ({
  background: theme?.styleOverrides?.Drawer?.backgroundColor,
  paddingBottom: '5rem',
  width: '20rem',
  [theme.breakpoints.up('md')]: {
    minWidth: '26rem'
  }
}));

const StyledButtonBox = styled(Box)(({ theme }) => ({
  background: theme.palette.booking.info,
  position: 'fixed',
  padding: '1rem',
  bottom: '1rem',
  textAlign: 'center',
  width: '20rem',
  [theme.breakpoints.up('md')]: {
    width: '26rem'
  }
}));

const StyledIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.action.active,
  cursor: 'pointer'
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.secondary.contrastText,
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.light, 0.4)
  },
  [theme.breakpoints.up('md')]: {
    width: '8rem'
  }
}));

const StyledFilterHeader = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  paddingRight: '0.7rem'
}));

const CatalogFilters = ({
  configFilters = [],
  setShowFilters = () => {},
  onApplyFilters = () => {},
  onResetFilters = () => {},
  onFilterChange = () => {},
  filterParams = {},
  filtersOptions = [],
  isFilterLoading = false
}) => {
  return (
    <>
      <StyledFilterBox data-testid='CatalogFilters'>
        <StyledFilterHeader>
          <Typography sx={{ mb: 2 }} variant='h6'>
            {Localize.get('Catalog.filters')}
          </Typography>
          <StyledIcon name='close' size='large' onClick={() => setShowFilters(false)}>
            close
          </StyledIcon>
        </StyledFilterHeader>
        {configFilters?.map((config) => (
          <DynamicFilters
            key={config.name}
            config={config}
            params={filterParams}
            onChange={onFilterChange}
            options={filtersOptions[config?.options]}
            isFilterLoading={isFilterLoading}
          />
        ))}
      </StyledFilterBox>
      <StyledButtonBox>
        <StyledButton sx={{ mr: 1 }} onClick={onResetFilters}>
          {Localize.get('App.reset')}
        </StyledButton>
        <StyledButton onClick={onApplyFilters}>{Localize.get('App.apply')}</StyledButton>
      </StyledButtonBox>
    </>
  );
};

export default CatalogFilters;
